import React from "react";
import styles from './AdNavigateBack.module.scss';
import {linksMap} from 'data/utils/constants';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import LinkBlockContainer from 'data/redux/containers/linkBlockContainer/LinkBlockContainer';
import {IProduct} from 'data/interfaces/products';
import {identifyTypeText, productToCategoryUrl,} from 'data/redux/constants/productsConstants';
import {getLastPossibleNavigation} from 'data/utils/shortcuts';
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';

export interface IAdNavigateBack {
  product: IProduct;
  isClickedPurchase: boolean;
  isProductOwner: boolean;
  isOrderOwner: boolean;
  children?: any;

  loading?: boolean;


  clearProductState?: (product: IProduct) => void;
}

/**
 * Generate a To url that leads back to the latest tourism query
 * @param router
 * @param history
 * @param props
 */
const preProcessesTo = (router, history, props) => {
  /**
   * Try to check if one of these paths was prior, else, use the default
   */
  return getLastPossibleNavigation(history,
      productToCategoryUrl(props.product),
      ...(props.isProductOwner ? [linksMap.productsByMe, linksMap.dashboard] : []),
      ...(props.isOrderOwner ? [linksMap.ordersByMe, linksMap.dashboard] : [])
    )
    || productToCategoryUrl(props.product);
};

const AdNavigateBack = ({loading, isClickedPurchase, ...props}: IAdNavigateBack) => loading ? <SkeletonPlaceHolder
  className={styles.adNavigateBackContainer}
  variant="text"
  width={124}/> : (
  isClickedPurchase ?
    <span className={styles.adNavigateBackContainer}
          onClick={() => props.clearProductState(props.product)}>
     <NavigateNextIcon/>
      חזרה למוצר
  </span>
    :
    <LinkBlockContainer
      preProcessesTo={(router, history) => preProcessesTo(router, history, props)}
      className={styles.adNavigateBackContainer}>
      <NavigateNextIcon/>
      חזרה ל{identifyTypeText(props.product)}</LinkBlockContainer>
);

AdNavigateBack.defaultProps = {
  product: {},
};

export default AdNavigateBack;
